module.exports = __webpack_public_path__ + "img/franchising_help_training1.a198412b.png";